import {
  axiosInstance,
  GET_ALL_VIDEOS,
  GET_VIDEO_BY_ID,
} from "../apiurls/apiurls";

export const getAllVideos = async (page, limit) => {
  try {
    const params = {};
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;
    const response = await axiosInstance.get(GET_ALL_VIDEOS, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching all videos:", error);
    throw error;
  }
};

export const getVideoById = async (id) => {
  try {
    const response = await axiosInstance.get(GET_VIDEO_BY_ID, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching video by ID:", error);
    throw error;
  }
};
